import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
} from "vue";

import {
  SelectFileDialog
} from "@/components/dialogs/";

import {
  IconTextButton
} from "@/components/buttons/";

import {
  useI18n,
  useSnackbar
} from "@/composables";

import {
  importCustomers
} from "@/components/customers/scripts";

import {
  ImportResult
} from "@/scripts/Common/types";

import {
  isEmpty
} from "@/scripts/Common/HelperFunctions";

import ImportCustomersResultDialog from "@/components/customers/children/ImportCustomersResultDialog.vue";
import InfoSnackbar from "@/components/children/InfoSnackbar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminImports',
  emits: [
  'onFetchError',
],
  setup(__props, { emit: emits }) {


const infoSnackbarRef = ref<InstanceType<typeof InfoSnackbar>>();
const {
  snackbarStatus,
  snackbarText,
  showSnackbar
} = useSnackbar(infoSnackbarRef);

const selectFileDialogRef = ref<InstanceType<typeof SelectFileDialog>>();
const importCustomersResultDialogRef = ref<InstanceType<typeof ImportCustomersResultDialog>>();
const importResult = ref<ImportResult>({
  successfulImports: 0,
  failedImports: 0,
  incorrectLinesAsCsv: ""
});

const {
  t,
} = useI18n();



const onCustomerImportIconClicked = () => {
  selectFileDialogRef.value?.show();
};

const onHandleFetchError = ({error}: { error: any }) => {
  if(error && error.ErrorCode === "ERR_VALIDATION_ERROR" && !isEmpty(error.ErrorMessage)){
    emits('onFetchError', {error: {error: error.ErrorMessage}})
    return;
  }
  emits('onFetchError', {error})
};

const onFileImportConfirm = async (file: File) => {
  const {response, error} = await importCustomers(file);

  if (error) {
    onHandleFetchError({error});
    return;
  }

  importResult.value = response;

  if (importResult.value.incorrectLinesAsCsv !== null) {
    importCustomersResultDialogRef.value?.show();
    return;
  }

  showSnackbar({
    status: "success",
    statusText: [t("SuccessfulImports", {count: importResult.value.successfulImports})],
  })
}


return { __sfc: true,infoSnackbarRef, snackbarStatus, snackbarText, showSnackbar, selectFileDialogRef, importCustomersResultDialogRef, importResult, t, emits, onCustomerImportIconClicked, onHandleFetchError, onFileImportConfirm, SelectFileDialog, IconTextButton, ImportCustomersResultDialog, InfoSnackbar }
}

})